import { render, staticRenderFns } from "./CarouselView.vue?vue&type=template&id=6c46f378&scoped=true"
import script from "../js/Carousel/index.js?vue&type=script&lang=js&external"
export * from "../js/Carousel/index.js?vue&type=script&lang=js&external"
import style0 from "./CarouselView.vue?vue&type=style&index=0&id=6c46f378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c46f378",
  null
  
)

export default component.exports